const expr = /\(?([0-9]{3})\)? ?([ .-]?)([0-9]{3})\2([0-9]{4})/;

// detect phone number
const includesPhoneNumber = (str: string) => expr.test(str);

export default includesPhoneNumber;
